import {
  ImageUtils
} from "./chunk-SEDOTBEN.js";
import "./chunk-SA55FI2N.js";
import {
  WidgetToolbarRepository
} from "./chunk-ZFACQRIZ.js";
import "./chunk-QHREOC7B.js";
import "./chunk-ZPQVM7W7.js";
import "./chunk-GJCFV3G2.js";
import "./chunk-R4FN2FPU.js";
import "./chunk-J3DZJUY2.js";
import {
  Plugin,
  isObject_default
} from "./chunk-H3OD3CNY.js";
import "./chunk-624QZG55.js";

// node_modules/@ckeditor/ckeditor5-image/src/imagetoolbar.js
var ImageToolbar = class extends Plugin {
  /**
   * @inheritDoc
   */
  static get requires() {
    return [WidgetToolbarRepository, ImageUtils];
  }
  /**
   * @inheritDoc
   */
  static get pluginName() {
    return "ImageToolbar";
  }
  /**
   * @inheritDoc
   */
  afterInit() {
    const editor = this.editor;
    const t = editor.t;
    const widgetToolbarRepository = editor.plugins.get(WidgetToolbarRepository);
    const imageUtils = editor.plugins.get("ImageUtils");
    widgetToolbarRepository.register("image", {
      ariaLabel: t("Image toolbar"),
      items: normalizeDeclarativeConfig(editor.config.get("image.toolbar") || []),
      getRelatedElement: (selection) => imageUtils.getClosestSelectedImageWidget(selection)
    });
  }
};
function normalizeDeclarativeConfig(config) {
  return config.map((item) => isObject_default(item) ? item.name : item);
}
export {
  ImageToolbar as default
};
/*! Bundled license information:

@ckeditor/ckeditor5-image/src/imagetoolbar.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)
*/
//# sourceMappingURL=@ckeditor_ckeditor5-image_src_imagetoolbar.js.map
